angular.module('impactx.basket').directive('appBasketSummary', function(){
    return {
        scope: {
            trns: '=',
            hasChanged: "=",
            refreshFunc: "&",
            updateButtonFunc: "&",
            price: '=',
            showNet: "=",
            showGross: "=",
            taxRates: "=",
            secondSummary: "<",
            summaryTranslation: "@",
            netSummaryTranslation: "@",
            grossSummaryTranslation: "@",
            budget: "=",
            showBudget: "=",
        },
        restrict:'E',
        templateUrl: 'modules/basket/includes/basketsummary.html',
        transclude: true
    };
});